module.exports = __webpack_public_path__ + "260526f6b4d4a7f86196443d7c043185.svg";